<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-columns text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li
        class="mt-3 nav-item"
        v-if="userLevel === PROFILES.ADMIN || userLevel === PROFILES.FACTURADOR || userLevel === PROFILES.REPORTES"
      >
        <h6

          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          Facturación
        </h6>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN || userLevel === PROFILES.FACTURADOR">
        <sidenav-item
          url="/clients"
          :class="getRoute() === 'clients' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'العملاء' : 'Clientes'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-users text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN || userLevel === PROFILES.FACTURADOR">
        <sidenav-item
          url="/invoices"
          :class="getRoute() === 'facturacion' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتير' : 'Facturación'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-receipt text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN || userLevel === PROFILES.FACTURADOR">
        <sidenav-item
          url="/invoices/credit_notes"
          :class="getRoute() === 'facturacion' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الفواتير' : 'Notas de Crédito'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-receipt text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          url="/reports/invoices"
          :class="getRoute() === 'billing-reports' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'التقارير' : 'Reportes'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-chart-bar text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li
        class="mt-3 nav-item"
        v-if="userLevel === PROFILES.ADMIN"
      >
        <h6

          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          Inventario
        </h6>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN">
        <sidenav-item
          url="/products"
          :class="getRoute() === 'products' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'المنتجات' : 'Productos'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-box text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN">
        <sidenav-item
          url="/settings/categories"
          :class="getRoute() === 'categories' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الطرق' : 'Categorías'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-tags text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN">
        <sidenav-item
          url="/settings/units"
          :class="getRoute() === 'units' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'الطرق' : 'Unidades de Medida'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-ruler-combined text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li
        class="mt-3 nav-item"
        v-if="userLevel === PROFILES.ADMIN"
      >
        <h6

          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'"
        >
          Configuraciones
        </h6>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN">
        <sidenav-item
          url="/settings/company"
          :class="getRoute() === 'company' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'التقارير' : 'Empresa'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-building text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="userLevel === PROFILES.ADMIN">
        <sidenav-item
          url="/settings/users"
          :class="getRoute() === 'users' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'التقارير' : 'Usuarios'"
          @click="toggleSidebar"
        >
          <template v-slot:icon>
            <i class="fa fa-user-lock text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      </ul>
    <div class="pt-3 mx-3 mt-3 sidenav-footer">
      <sidenav-card
        :class="cardBg"
        textPrimary="Need Help?"
        textSecondary="Please check our docs"
      />
    </div>
    </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";
import { mapMutations } from "vuex";
export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      userLevel: parseInt(localStorage.getItem('userLevel')) || 0, // Aseguramos que sea un número
      PROFILES: {
        ADMIN: 1,
        FACTURADOR: 2,
        REPORTES: 3,
      }
    };
  },
  components: {
    SidenavItem,
    SidenavCard
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    ...mapMutations(["navbarMinimize"]),
    toggleSidebar() {
        this.navbarMinimize();
      }
  }
};
</script>